;(function ( $ ) {

    /**
     *  guidedTour
     *  create tour slides
     **/

    'use strict';

    // Create the defaults once
    var pluginName = 'guidedTour';
    var defaults = {
        scrollDuration: 400,
        scrollEasing: 'easeInOutCubic'
    };

    // The actual plugin constructor
    function Plugin ( element, options ) {
        this.element = element;
        this.settings = $.extend( {}, defaults, options );
        this._defaults = defaults;
        this._name = pluginName;
        this.init();
    }

    // Avoid Plugin.prototype conflicts
    $.extend(Plugin.prototype, {
        init: function () {
            this.$slides = $(this.element).find('.tour-card');
            this.$wrapper = $(this.element).find('.guided-tour-wrapper');
            this.currentSlide = 0;
            this.skipLinkHref = $(this.element).find('.skip-link a').attr('href');
            this.setSlideDimensions();
            this.renderSlideNavigation();
            this.renderNextButton();
            this.registerEvents();
        },

        renderSlideNavigation: function() {
            this.$navigation = $('<ul class="slide-navigation" />');
            for (var i = 0; i < this.$slides.length; i++) {
                if (!i) {
                    this.$navigation.append('<li><a href="#" class="navigation-bullet border-color-event bg-color-event bg-color-event-darker-hover" data-index="' + i + '"></a></li>');
                } else {
                    this.$navigation.append('<li><a href="#" class="navigation-bullet border-color-event bg-color-event-darker-hover" data-index="' + i + '"></a></li>');
                }
            }
            $(this.element).append(this.$navigation);
        },

        renderNextButton: function() {
            this.$nextButton = $('<a href="#" class="next-slide color-event color-event-darker-hover"><span class="icon icon-arrow-down"></span></a>');
            $(this.element).append(this.$nextButton);
        },

        setSlideDimensions: function() {
            var _this = this;
            var paddingBottom = 80;
            this.maxHeight = 0;
            this.$slides.each(function() {
                $(this).css('height', 'auto');
                if ($(this).height() > _this.maxHeight) {
                    _this.maxHeight = $(this).height();
                }
            });
            this.$slides.each(function() {
                $(this).height(_this.maxHeight);
                paddingBottom = parseInt($(this).css('padding-bottom'));
            });
            this.$wrapper.height(this.maxHeight + paddingBottom);
            $(this.element).css({
                'position': 'relative',
                'height': this.maxHeight + paddingBottom + 60
            });
            this.$wrapper.css({
                'overflow': 'hidden',
                'position': 'relative'
            });
            this.$wrapper.animate({
                'scrollTop': (this.maxHeight + paddingBottom) * this.currentSlide
            }, this.settings.scrollDuration, this.settings.scrollEasing);
        },

        registerEvents: function() {
            var _this = this;
            $(this.element).on('click', '.navigation-bullet', function(e) {
                e.preventDefault();
                $(_this.element).find('.navigation-bullet.bg-color-event').removeClass('bg-color-event');
                _this.currentSlide = $(this).data('index');
                var top = $(_this.element).find('.tour-card:eq(' + _this.currentSlide + ')').position().top;
                _this.$wrapper.animate({
                    'scrollTop': top
                }, _this.settings.scrollDuration, _this.settings.scrollEasing);
                $(this).addClass('bg-color-event');
            });
            $(this.element).on('click', '.next-slide', function(e) {
                e.preventDefault();
                _this.currentSlide++;
                if (_this.currentSlide >= _this.$slides.length) {
                    if (_this.skipLinkHref) {
                        window.location.href = _this.skipLinkHref;
                    } else {
                        _this.currentSlide = 0;
                    }
                }
                var top = $(_this.element).find('.tour-card:eq(' + _this.currentSlide + ')').position().top;
                $(_this.element).find('.navigation-bullet.bg-color-event').removeClass('bg-color-event');
                _this.$wrapper.animate({
                    'scrollTop': top
                }, _this.settings.scrollDuration, _this.settings.scrollEasing);
                $(_this.element).find('.navigation-bullet:eq(' + _this.currentSlide + ')').addClass('bg-color-event');
            });
            $(window).smartresize(function() {
                _this.setSlideDimensions();
            });
        }
    });

    $.fn[ pluginName ] = function ( options ) {
        return this.each(function() {
            if ( !$.data( this, 'plugin_' + pluginName ) ) {
                $.data( this, 'plugin_' + pluginName, new Plugin( this, options ) );
            }
        });
    };
})( jQuery );
